// NOTE: Do not import these from lib root! Will cause circular deps
import { AngleBottom } from '../../icons/index';
export const getThemeSelect = (_tokens) => {
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: AngleBottom,
            },
            styleOverrides: {
                select: {
                    minWidth: '180px',
                    display: 'flex',
                    alignItems: 'center',
                },
            },
        },
    };
};
